<app-search-input-autocomplete
  [searchType]="searchType"
  [placeType]="placeType"
  [query]="query"
  [isMobile]="isMobile"
  [title]="isDestinationSelected ? ('SEARCH_MODULE.DESTINATION_INPUT_HEADER' | transloco): (inputPlaceListLabel | transloco)"
  [viewAutocomplete]="viewAutocomplete"
  [inputPlaceListIcon]="inputPlaceListIcon"
  [inputPlaceListLabel]="inputPlaceListLabel | transloco"
  [inputPlaceListPlaceholder]="inputPlaceListPlaceholder | transloco"
  [isLoadingAutocompletePlaces]="isLoadingAutocompletePlaces"
  [cityAndAirportsAutocomplete]="cityAndAirportsAutocomplete"
  [hotelAndLocationsAutocomplete]="hotelAndLocationsAutocomplete"
  (closeAutocomplete)="closeAutocomplete.emit()"
  (setQuery)="setQuery.emit($event)"
  (popularAmplitudeEvent)="popularAmplitudeEvent.emit($event)"
  (selectAirportOrCityEvent)="selectAirportOrCityEvent.emit($event)"
  (selectLocationEvent)="selectLocationEvent.emit($event)"
  (selectHotelEvent)="selectHotelEvent.emit($event)"
  (selectPopularPlace)="selectPopularPlace.emit($event)">
</app-search-input-autocomplete>
